import { Image } from "src/types/storefront";
import Slider from "./Slider";
import FullscreenSlider from "./SliderFullscreen";
import SliderWithZoom from "./SliderWithZoom";

type GalleryProps = {
  images: Image[];
  fullScreen: boolean;
  setFullscreen: React.Dispatch<React.SetStateAction<boolean>>;
  withFrenchTechnologyLogo?: boolean;
};

function NewGallery({
  images,
  fullScreen,
  setFullscreen,
  withFrenchTechnologyLogo,
}: GalleryProps) {
  return (
    <>
      <div className="hidden lg:block">
        <SliderWithZoom
          images={images}
          imageContainerClassName="aspect-[6/8] animate-pulse-bg"
          imageClassName="h-full w-full object-cover object-center"
          setFullscreen={setFullscreen}
          withFrenchTechnologyLogo={withFrenchTechnologyLogo}
        />
      </div>
      <div className="lg:hidden">
        <Slider
          images={images}
          imageContainerClassName="aspect-[1/1] animate-pulse-bg"
          imageClassName="w-full h-full object-cover object-center"
        />
      </div>

      {fullScreen && (
        <FullscreenSlider
          images={images}
          activeImage={0}
          setFullscreen={setFullscreen}
        />
      )}
    </>
  );
}

export default NewGallery;
